import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import NotificationForm from '../components/NotificationForm';
import { useCreateNotification } from '../hooks/useNotificationMutations';

export default function NotificationCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreateNotification();

  const handleSubmit = (data: any) => {
    mutation.mutate(data, { onSuccess: () => navigate('/notifications') });
  };

  return (
    <div>
      <PageHeader back title={t('notifications.createTitle')} subtitle={t('notifications.createSubtitle')} />
      <Card>
        <NotificationForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
